<div class="use-case-preview">
  @if (state() === "loading") {
    <p class="use-case-preview__status">
      {{ "use-case-wizard.preview.status.building-plan" | translate }}
    </p>
  } @else if (state() === "error") {
    <p class="use-case-preview__status use-case-preview__status--error">
      {{ "use-case-wizard.preview.status.failed-to-build-plan" | translate }}
    </p>
  } @else if (preview(); as plan) {
    <app-use-case-plan-summary
      class="use-case-preview__body"
      [preview]="plan"
      [provisionFailure]="provisionFailure()"
    ></app-use-case-plan-summary>
  } @else {
    <p class="use-case-preview__status">
      {{ "use-case-wizard.preview.status.no-plan-yet" | translate }}
    </p>
  }
</div>
